module.exports = __webpack_public_path__ + "img/creditCardAddRe.1342b080.svg";